import { render, staticRenderFns } from "./business-contract-confirmation-form.vue?vue&type=template&id=5bf83864&"
import script from "./business-contract-confirmation-form.vue?vue&type=script&lang=js&"
export * from "./business-contract-confirmation-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports